'use strict';

angular.module('app.campaignActivity')
    .directive('campaignInfluencerInfo', function ($rootScope, $state, campaignConsts) {
        var controller = function () {
            var vm = this;

            vm.goToMeasurePage = function () {
                $rootScope.$broadcast('select_campaign', { campaign_id : $rootScope.saveParams.project_id });

                $state.transitionTo('home.measure', {
                    reload: false,
                    inherit: true,
                    notify: true
                });
            }

            function init() {
                vm.showInfluencerActions = $rootScope.currentUser.role.accessLevel !== 'influencer';

                if (vm.influencer) {
                    vm.showMeasure = vm.influencer.campaign.projectType === campaignConsts.Types.CAMPAIGN_CREATION;
                }
            }

            init();
        };

        return {
            restrict: 'E',
            scope: {
                influencer: '=',
                onDeleteInfluencer: '&'
            },
            controller: controller,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'app/campaign/campaignActivityPage/influencerInfo/campaignInfluencerInfo.html?app_v=deployDate'
        };
    });